import React from 'react';
import { Phone } from 'lucide-react';

// Hardcoded so the error UI works even if mock/data imports fail.
const SUPPORT_PHONE_DISPLAY = '0499 923 699';
const SUPPORT_PHONE_RAW = '+61499923699';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="error-boundary-fallback"
        className="min-h-screen flex items-center justify-center bg-slate-50 px-4"
      >
        <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-slate-200 p-8 text-center">
          <h1 className="text-2xl font-bold text-slate-900 mb-3">Something went wrong</h1>
          <p className="text-slate-600 mb-6">
            We're sorry — something didn't load correctly. Please reload the page or call us directly.
          </p>
          <div className="flex flex-col gap-3">
            <button
              onClick={this.handleReload}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              Reload the website
            </button>
            <a
              href={`tel:${SUPPORT_PHONE_RAW}`}
              className="w-full inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              <Phone size={18} />
              Call {SUPPORT_PHONE_DISPLAY}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
